import { render, staticRenderFns } from "./InternationalReturnsAndExchangeList.vue?vue&type=template&id=30f43a16&scoped=true"
import script from "./InternationalReturnsAndExchangeList.vue?vue&type=script&lang=js"
export * from "./InternationalReturnsAndExchangeList.vue?vue&type=script&lang=js"
import style0 from "./InternationalReturnsAndExchangeList.vue?vue&type=style&index=0&id=30f43a16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f43a16",
  null
  
)

export default component.exports